import React from "react";
import Swiper from "react-id-swiper";
import {Autoplay, EffectCoverflow, Mousewheel} from "swiper/modules";
import fiveStar from "../../../assets/icons/5star.svg";
import image from "../../../assets/icons/signInBoxDecor.svg";
import "./style.scss";

const SwiperCoverflow = () => {
  const ReviewData = [
    {
      profilePic: fiveStar,
      heading: "MEMEKIYA AMARE",

      information: "Got my first payout from Equityedge,it was so smooth and fast.Best propfirm atm!great customer support.Thanks Equity Edge specially Christian and Ashraf.You guys are real Legends",
    },
    {
      profilePic: fiveStar,
      heading: "Berkay Rami",
      information: "i've had problem with the payout but Martin and Nasdom were so much helpfull and they solved them i received my payout Thanks EE!",
    },
    {
      profilePic: fiveStar,
      heading: "Andrycha",
      information: "No delays during processing, i received instantaneous replies. Great trading, easy to use platform",
    },
    {
      profilePic: fiveStar,
      heading: "Yonatan Nebiyu",
      information: "The stuff especially the one that helped me personally(usman)is what i like most about the company so far.",
    },
    {
      profilePic: fiveStar,
      heading: "Ikenna Enyinna",
      information: "They have great customer service, I made a complaint and Hillary was fast to respond with answers",
    },
  ];

  const params = {
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",
    loop: true,
    coverflowEffect: {
      rotate: 0,
      stretch: -50,
      depth: 250,
      modifier: 3.5,
      slideShadows: false,
    },

    pagination: {
      el: ".swiper-pagination",
    },
  };

  return (
    <Swiper
      {...params}
      modules={[EffectCoverflow]}
    >
      {ReviewData.map((item, index) => (
        <div
          className="sliderSect"
          key={index}
        >
          <div className="titleSect">
            <div className="profilePic">
              <img
                src={item.profilePic}
                alt=""
              />
            </div>
            <div className="Title">
              <div className="heading">
                <h5>{item.heading}</h5>
              </div>
              <div className="countryName">
                <p>{item.country}</p>
              </div>
            </div>
          </div>
          <div className="decorImg">
            <img
              src={image}
              alt=""
            />
          </div>
          <div className="infoSect">
            <p>{item.information}</p>
          </div>
        </div>
      ))}
    </Swiper>
  );
};

export default SwiperCoverflow;
